import styled from 'styled-components';
import { CardChart } from '../../../../../../utils/styles';

export const CardTable = styled(CardChart)`
  height: auto;
  padding: 0;
`;
